import React, { ReactNode } from 'react';
if (process.env.MAIL_APP_PLATFORM === 'h5') {
    require('./style_h5.scss');
} else {
    require('./style.scss');
}

interface IProps {
    children: ReactNode
}

const TopTips: React.FC<IProps> = ({ children }) => {
    return (
        <div className="top-tips">
            { children }
        </div>
    )
}

export default TopTips;
